import { render, staticRenderFns } from "./ListLabourerSchedulePage.vue?vue&type=template&id=54623f7a&"
import script from "./ListLabourerSchedulePage.vue?vue&type=script&lang=js&"
export * from "./ListLabourerSchedulePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports